module.exports = {"211002016":"文圣街道","211002017":"武圣街道","211002018":"南门街道","211002019":"襄平街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211002.json
// module id = 659
// module chunks = 0